<template>
    <div class="container mb-3" v-if="assignedTermsAndCondition && assignedTermsAndCondition.service_group && assignedTermsAndCondition.is_beginning_terms != 0">
        <div>       
            <div class="terms-condition" v-if="selectedFormatted != 'yes'" >
                <div class="terms-beginning-content" v-html="assignedTermsAndCondition.beginning_content"></div>
                <div class="ml-3">
                    <div v-for="(option) in assignedTermsAndCondition.yes_option" :key="option.term_text_id" class="form-check">
                        <input  
                        v-model="selected"
                        type="radio" 
                        name="termsAndConditionsChoice" 
                        :id="'termsOption' + option.term_text_id"
                        :value="'yes'+option.term_text_id" 
                        @change="selectedOptionTerms" 
                        >
                        <label class="form-check-label" :for="'termsOption' + option.term_text_id" tabindex="0" @keydown="event => { selectedOptionTermsKeyEvent(event, 'termsOption' + option.term_text_id) }">{{ option.term_text }}</label>
                    </div>
                    <div v-for="(option) in assignedTermsAndCondition.no_option" :key="option.term_text_id" class="form-check">
                        <input  
                        v-model="selected"
                        ref="termsno"
                        type="radio" 
                        name="termsAndConditionsChoice"
                        :id="'termsOption' + option.term_text_id" 
                        :value="'no'+option.term_text_id"
                        @change="selectedOptionTerms"
                        data-bs-toggle="modal"
                        data-bs-target="#termsandcondition"
                        >
                        <label class="form-check-label" :for="'termsOption' + option.term_text_id" tabindex="0" @keydown="event => { selectedOptionTermsKeyEvent(event, 'termsOption' + option.term_text_id) }">{{ option.term_text }}</label>
                    </div>

                </div>
            </div>
            
            <div id="termsCondition" v-show="selectedFormatted == 'yes'"  class="terms-condition no-gutters mt-2 faqs">
                <div class="card col-md-12 col-lg-6">
                    <a class="collapsed card-link" data-bs-toggle="collapse" href="#termsConditionToggle">
                        <div class="card-header arrow" v-html="TEXTS.render(`TERMS_AND_CONDITIONS_SELECTED_YES`)"></div>
                    </a>
                    <div id="termsConditionToggle" class="collapse" data-bs-parent="#termsCondition">
                        <div class="card-body" v-html="assignedTermsAndCondition.beginning_content"></div>
                    </div>
                </div>
            </div>
            <terms-and-agreement-modal />
        </div>
    </div>
</template>

<script>
import TermsAndAgreementModal from '../../../../common/components/TermsAndAgreementModal';
import GeneralBookingSettingMixin from '../../../../common/mixins/GeneralBookingSettingMixin';
import Texts from '../../../../common/utils/Texts'

    export default {
        mixins: [GeneralBookingSettingMixin],
        components: {
            TermsAndAgreementModal
        },
        props: {
        },
        data() {
            return {
                selected: '',
                endTerm: '',
                endTermsContent: '',
                endTermsContent2: '',
                endTermsContent3: '',
                endTermsHeader: '',
                cachedServiceGroupId: null,

                // Task: BAUM-395
                selectedServiceGroupIdAvailable: false
            }
        },
        computed: {
            TEXTS: () => Texts,
            selectedFormatted(){
                if(!this.selected){
                    return null
                }
                if(this.selected.indexOf('yes') > -1){
                    return 'yes'
                }
                else if(this.selected.indexOf('no') > -1){
                    return 'no'
                }
                else {
                    return null
                }
            },
            bookingState : function(){
                return this.$store.getters.GET_BOOKING_STATE
            },
            userType(){
                return this.$store.getters.GET_PERSONAL_INFO.type;
            },
            termsAndConditionsList : function(){
                return this.$store.getters.GET_TERMS_CONDITION.list;
            },
            selectedServiceGroupId : function(){
                var selectedServiceGroup = this.$store.getters.GET_BOOKING_STATE.selectedServiceGroup;
                return selectedServiceGroup != null ? selectedServiceGroup.service_group_id : null;
            },
            isAgreedToTerms : function(){
                return this.$store.getters.GET_BOOKING_STATE.isAgreedToTerms;
            },
            assignedTermsAndCondition : function(){
                // Get the list of terms and conditions 
                if(!this.termsAndConditionsList || this.termsAndConditionsList.length == 0 || !this.selectedServiceGroupId){
                    return;
                }
                
                // Terms and Condition Reset when changing service group
                if(this.isAgreedToTerms !== 'yes' || this.isAgreedToTerms == true){ 
                    this.selected =  null;
                }

                var foundTerms = this.termsAndConditionsList.find(termsAndConditions =>{
                    if(termsAndConditions.service_group && this.selectedServiceGroupId == termsAndConditions.service_group.service_group_id){
                        this.endTerm = termsAndConditions.is_end_terms;
                        this.endTermsContent = termsAndConditions.end_terms_content;
                        this.endTermsContent2 = termsAndConditions.end_terms_content_2;
                        this.endTermsContent3 = termsAndConditions.end_terms_content_3;
                        this.endTermsHeader = termsAndConditions.end_terms_header;
                        return true;
                    }
                    else{
                        return false;
                    }
                }) 

                if(this.endTerm) {
                    this.endTerm = 'yes';
                }

                if(!foundTerms || foundTerms.is_beginning_terms == 0){
                    // Force Yes
                    this.selected = 'yes';
                    this.selectedOptionTerms();
                }else if(!this.cachedServiceGroupId || this.cachedServiceGroupId != this.selectedServiceGroupId){
                    this.cachedServiceGroupId = this.selectedServiceGroupId
                    if( this.$refs.termsno && Array.isArray(this.$refs.termsno)){
                        for (let i = 0; i < this.$refs.termsno.length; i++) {
                            const termsno = this.$refs.termsno[i];
                            termsno.checked = false     
                        }
                    }
                }
                
                return foundTerms;
            }

        },
        mounted() {
            this.$store.dispatch('getTermsCondition')
        },
        methods: {
            determinePreselection() {
                // --- Always Auto Select for CSO
                if(this.generalBookingSetting) {
                    const {is_autoselect_for_cso } = this.generalBookingSetting;

                    if(this.userType == "cso" && is_autoselect_for_cso === 1){
                        this.selected = 'yes';
                        this.selectedOptionTerms();
                        return
                    }
                }
                
                if (!this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) return;

                const service_group_id = this.$store.getters.GET_ACTIVE_SERVICE_GROUP.service_group_id;
                const stored = this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_ACCEPTED_BOOKING_TERMS.find(group => group.service_group_id === service_group_id);
                if (stored && stored.isAgreedToTerms === 'yes') {
                    this.selected = 'yes';
                    this.selectedOptionTerms();
                }
            },
            selectedOptionTerms() {
                var bookingState = this.bookingState; // Shallow Cloning
                if(bookingState.isAgreedToTerms != this.selectedFormatted){
                    bookingState.hasEndTerms = this.endTerm;
                    bookingState.isAgreedToTerms = this.selectedFormatted;
                    bookingState.endTermsContent = this.endTermsContent;
                    bookingState.endTermsContent2 = this.endTermsContent2;
                    bookingState.endTermsContent3 = this.endTermsContent3;
                    bookingState.endTermsHeader = this.endTermsHeader;
                    this.$store.dispatch("setBookingState", bookingState);
                    this.$emit('nextsection')

                    this.$store.dispatch('setActiveMultipleServiceBookingTerms',
                        {
                            hasEndTerms: this.endTerm,
                            isAgreedToTerms: this.selectedFormatted,
                            endTermsContent: this.endTermsContent,
                            endTermsContent2: this.endTermsContent2,
                            endTermsContent3: this.endTermsContent3,
                            endTermsHeader: this.endTermsHeader
                        }
                    );
                }
            },
            selectedOptionTermsKeyEvent(event, radioId){
                if(radioId && (event.keyCode == 32 || event.keyCode == 13)){
                    event.preventDefault();
                    var checkbox = $("#" + radioId)[0]
                    checkbox.checked = !checkbox.checked
                    this.selected = checkbox.value
                    if(this.selectedFormatted === 'no'){
                        $('#termsandcondition').modalbs5('show')
                    }
                    this.selectedOptionTerms()
                }
            }
        },
        watch: {
            'selectedServiceGroupId': function(newId, oldId) {
                if (newId !== oldId) {
                    /**
                    * Task:     BAUM-395
                    * Author:   Joseph Ricohermoso
                    * Date:     2021-05-26
                    * Desc:     Move determine function and collapse call in a different location.
                    *           Added new model variable that holds bool value.
                    */
                    // this.determinePreselection();
                    // $("#termsConditionToggle").collapse("hide")
                    this.selectedServiceGroupIdAvailable = !!newId;
                }
            },
            /**
            * Task:     BAUM-395
            * Author:   Joseph Ricohermoso
            * Date:     2021-05-26
            * Desc:     Only determine start terms auto-accept once the terms data is fully loaded.
            *           If service group is available and terms data is loaded. Start determining. 
            */
            assignedTermsAndCondition: function(newContent) {
                if (newContent && this.selectedServiceGroupIdAvailable) {
                    this.determinePreselection();
                    $("#termsConditionToggle").collapse("hide")
                }
            },
            
        }
    }
</script>